/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

// Action Creator
export const types = {
  FETCH_CONNECTORS: "[Connectors] Fetch connectors",
  FETCH_CONNECTORS_SUCCESS: "[Connectors] Fetch connectors success",
  FETCH_CONNECTORS_FAILED: "[Connectors] Fetch connectors failed",

  LOAD_MORE_CONNECTORS: "[Connectors] Load More connectors",
  LOAD_MORE_CONNECTORS_SUCCESS: "[Connectors] Load More connectors success",
  LOAD_MORE_CONNECTORS_FAILED: "[Connectors] Load More connectors failed",

  FETCH_A_CONNECTOR: "[Connectors] Fetch a connector",
  FETCH_A_CONNECTOR_SUCCESS: "[Connectors] Fetch a connector success",
  FETCH_A_CONNECTOR_FAILED: "[Connectors] Fetch a connector failed",

  CHANGE_CONNECTOR_STATUS: "[Connectors] Change connector status",
  CHANGE_CONNECTOR_STATUS_SUCCESS:
    "[Connectors] Change connector status success",
  CHANGE_CONNECTOR_STATUS_FAILED: "[Connectors] Change connector status failed",

  REMOVE_CONNECTOR: "[Connectors] Remove current connector",
  REMOVE_VALIDATION: "[Connectors] Remove current validation",

  CREATE_CONNECTOR: "[Connectors] Create connector",
  CREATE_CONNECTOR_SUCCESS: "[Connectors] Create connector success",
  CREATE_CONNECTOR_FAILED: "[Connectors] Create connector failed",

  VALIDATE_CONNECTOR: "[Connectors] Validate connector",
  VALIDATE_CONNECTOR_SUCCESS: "[Connectors] Validate connector success",
  VALIDATE_CONNECTOR_FAILED: "[Connectors] Validate connector failed",

  UPDATE_CONNECTOR: "[Connectors] Update connector",
  UPDATE_CONNECTOR_SUCCESS: "[Connectors] Update connector success",
  UPDATE_CONNECTOR_FAILED: "[Connectors] Update connector failed",
  FETCH_CONNECTOR_OF_DATAPIPE: "[Connectors] Fetch connector of datapipe",
  FETCH_CONNECTOR_OF_DATAPIPE_SUCCESS:
    "[Connectors] Fetch connector of datapipe success",
  FETCH_CONNECTOR_OF_DATAPIPE_FAIL:
    "[Connectors] Fetch connector of datapipe fail",
  // NEW
  SET_CONNECTOR_FILTER_ACTIVE_DISABLE:
    "[Connectors] Set connector Active Disable ",
  REMOVE_CONNECTOR_FILTER_ACTIVE_DISABLE:
    "[Connectors] Remove connector Active Disable ",
  // END
  DELETE_CONNECTOR: "[Connectors] Delete connector",
  DELETE_CONNECTOR_SUCCESS: "[Connectors] Delete connector success",
  DELETE_CONNECTOR_FAILED: "[Connectors] Update connector failed",

  FETCH_A_CONNECTOR_DEL: "[Connectors] Fetch a connector del",
  FETCH_A_CONNECTOR_DEL_SUCCESS: "[Connector] Fetch a connector del success",
  FETCH_A_CONNECTOR_DEL_FAILED: "[Connectors] Fetch a connector del failed",
  REMOVE_DEL_CONNECTOR: "[Connectors] Remove del connector",
  CLEAR_CONNECTOR: "[Connectors] Clear Connectors",
  UPDATE_LINK_CONNECTOR: "[Connectors] Update Link connector",
  UPDATE_LINK_CONNECTOR_SUCCESS: "[Connectors] Update Link connector success",
  UPDATE_LINK_CONNECTOR_FAILED: "[Connectors] Update Link connector failed",
  UPDATE_CONNECTOR_LIST: "[Connectors] Update connector List ",
  VALIDATE_CONNECTOR_NAME: "[Connectors] Validate connector Name",
  VALIDATE_CONNECTOR_NAME_SUCCESS:
    "[Connectors] Validate connector Name success",
  VALIDATE_CONNECTOR_NAME_FAILED: "[Connectors] Validate connector Name failed",

  REMOVE_VALIDATION_NAME: "[Connectors] Remove Validate Name",
  FETCH_A_CONNECTOR_CONFIG_STATS: "[Connectors] Fetch a Connector Confi stats",
  FETCH_A_CONNECTOR_CONFIG_STATS_SUCCESS:
    "[Connectors] Fetch a Connector stats success",
  FETCH_A_CONNECTOR_CONFIG_STATS_FAILED:
    "[Connectors] Fetch a Connector Config stats failed",
  CLEAR_CONNECTOR_CONFIG_STATS: "[Connectors] Clear Connectors Config stats",
  CLEAR_CONNECTOR_LIST: "[Collectors] Clear Connector list",

  FETCH_CONNECTOR_LOGS: "[Connectors] Fetch a Connector Logs",
  FETCH_CONNECTOR_LOGS_SUCCESS: "[Connectors] Fetch a Connector Logs Success ",
  FETCH_CONNECTOR_LOGS_FAILED: "[Connectors] Fetch a Connector Logs Failed",

  FETCH_BIGQUERY_MAPPING: "[Connectors] Fetch bigquery mapping",
  FETCH_BIGQUERY_MAPPING_SUCCESS: "[Connectors] Fetch bigquery mapping success",
  FETCH_BIGQUERY_MAPPING_FAILED: "[Connectors] Fetch bigquery mapping failed",

  BIGQUERY_UPDATE: "[Connectors] Bigquery mapping update",
  BIGQUERY_UPDATE_SUCCESS: "[Connectors]  Bigquery update success",
  BIGQUERY_UPDATE_FAILED: "[Connectors] Bigquery update failed",
  RESET_BIGQUERY_UPDATE_MSGS: "[Connectors] Reset bigquery mapping update mgs",

  CLEAR_CONNECTOR_ERROR: "[Connectors] Clear Connector Erorr",
};
//
// ─── FETCH CONNECTOR ACTIONS ────────────────────────────────────────────────────
//

export const FetchConnectors = (
  companyId,
  status,
  page,
  size,
  order,
  query,
  field,
  projectId,
  filters,
  initialFilter,
) => ({
  type: types.FETCH_CONNECTORS,
  payload: {
    companyId,
    status,
    page,
    size,
    order,
    query,
    field,
    projectId,
    filters,
    initialFilter,
  },
});
export const FetchConnectorsSuccess = /* istanbul ignore next */ (list) => ({
  type: types.FETCH_CONNECTORS_SUCCESS,
  payload: list,
});
export const FetchConnectorsFailed = (error) => ({
  type: types.FETCH_CONNECTORS_FAILED,
  payload: error,
});

//
// ─── LOAD MORE CONNECTOR ───────────────────────────────────────────────────
//
export const LoadMoreConnectors = (
  companyId,
  status,
  page,
  size,
  order,
  query,
  field,
  projectId,
  filters,
) => ({
  type: types.LOAD_MORE_CONNECTORS,
  payload: {
    companyId,
    status,
    page,
    size,
    order,
    query,
    field,
    projectId,
    filters,
  },
});
export const LoadMoreConnectorsSuccess = /* istanbul ignore next */ (list) => ({
  type: types.LOAD_MORE_CONNECTORS_SUCCESS,
  payload: list,
});
export const LoadMoreConnectorsFailed = /* istanbul ignore next */ (error) => ({
  type: types.LOAD_MORE_CONNECTORS_FAILED,
  payload: error,
});

//
// ─── FETCH A SINGLE CONNECTOR ───────────────────────────────────────────────────
//
export const FetchAConnector = (id) => ({
  type: types.FETCH_A_CONNECTOR,
  payload: id,
});
export const FetchAConnectorSuccess = (list) => ({
  type: types.FETCH_A_CONNECTOR_SUCCESS,
  payload: list,
});
export const FetchAConnectorFailed = (error) => ({
  type: types.FETCH_A_CONNECTOR_FAILED,
  payload: error,
});
//
// ─── CHANGE CONNECTOR STATUS ACTIONS ────────────────────────────────────────────
//

export const ChangeConnectorStatus = (connector) => ({
  type: types.CHANGE_CONNECTOR_STATUS,
  payload: connector,
});
export const ChangeConnectorStatusSuccess = (response) => ({
  type: types.CHANGE_CONNECTOR_STATUS_SUCCESS,
  payload: response,
});
export const ChangeConnectorStatusFailed = (error) => ({
  type: types.CHANGE_CONNECTOR_STATUS_FAILED,
  payload: error,
});

//
// ─── REMOVE SINGLE CONNECTOR ACTIONS ────────────────────────────────────────────────────
//

export const RemoveConnector = (id) => ({
  type: types.REMOVE_CONNECTOR,
  payload: id,
});
//
// ─── CREATE CONNECTOR ACTIONS ────────────────────────────────────────────────────
//
export const CreateConnector = (connector) => ({
  type: types.CREATE_CONNECTOR,
  payload: connector,
});
export const CreateConnectorSuccess = (response) => ({
  type: types.CREATE_CONNECTOR_SUCCESS,
  payload: response,
});
export const CreateConnectorFailed = (error) => ({
  type: types.CREATE_CONNECTOR_FAILED,
  payload: error,
});
//
// ─── UPDATE CONNECTOR ACTIONS ────────────────────────────────────────────────────
//
export const UpdateConnector = (connector, id) => ({
  type: types.UPDATE_CONNECTOR,
  payload: { connector, id },
});
export const UpdateConnectorSuccess = (response) => ({
  type: types.UPDATE_CONNECTOR_SUCCESS,
  payload: response,
});
export const UpdateConnectorFailed = (error) => ({
  type: types.UPDATE_CONNECTOR_FAILED,
  payload: error,
});
//
// ─── FETCH SINGLE CONNECTOR OF DATAPIPE ACTIONS ────────────────────────────────────────────────────
//

export const FetchConnectorOfDatapipe = (id) => ({
  type: types.FETCH_CONNECTOR_OF_DATAPIPE,
  payload: id,
});
export const FetchConnectorOfDatapipeSuccess = (list) => ({
  type: types.FETCH_CONNECTOR_OF_DATAPIPE_SUCCESS,
  payload: list,
});
export const FetchConnectorOfDatapipeFail = /* istanbul ignore next */ (
  error,
) => ({
  type: types.FETCH_CONNECTOR_OF_DATAPIPE_FAIL,
  payload: error,
});
//
// ─── VALIDATE CONNECTOR STATUS ────────────────────────────────────────────────────
//

export const ValidateConnectors = (id) => ({
  type: types.VALIDATE_CONNECTOR,
  payload: id,
});
export const ValidateConnectorsSuccess = (status) => ({
  type: types.VALIDATE_CONNECTOR_SUCCESS,
  payload: status,
});
export const ValidateConnectorsFail = (status) => ({
  type: types.VALIDATE_CONNECTOR_FAILED,
  payload: status,
});

export const RemoveValidation = (id) => ({
  type: types.REMOVE_VALIDATION,
  payload: id,
});
export const SetConnectorFilterActiveDisable = (filter) => ({
  type: types.SET_CONNECTOR_FILTER_ACTIVE_DISABLE,
  payload: filter,
});
export const RemoveConnectorFilterActiveDisable = () => ({
  type: types.REMOVE_CONNECTOR_FILTER_ACTIVE_DISABLE,
});
// /////////Delete Connector//////////
export const DeleteConnector = (id) => ({
  type: types.DELETE_CONNECTOR,
  payload: id,
});
export const DeleteConnectorSuccess = (response) => ({
  type: types.DELETE_CONNECTOR_SUCCESS,
  payload: response,
});
export const DeleteConnectorFailed = (response) => ({
  type: types.DELETE_CONNECTOR_FAILED,
  payload: response,
});
export const FetchAConnectorDel = (id) => ({
  type: types.FETCH_A_CONNECTOR_DEL,
  payload: id,
});
export const FetchAConnectorDelSuccess = (list) => ({
  type: types.FETCH_A_CONNECTOR_DEL_SUCCESS,
  payload: list,
});
export const FetchAConnectorDelFailed = (error) => ({
  type: types.FETCH_A_CONNECTOR_DEL_FAILED,
  payload: error,
});
export const RemoveDelConnector = (id) => ({
  type: types.REMOVE_DEL_CONNECTOR,
  payload: id,
});
export const ClearConnector = () => ({
  type: types.CLEAR_CONNECTOR,
});
// ////////

// ─── UPDATE CONNECTOR ACTIONS ────────────────────────────────────────────────────
//
export const UpdateLinkConnector = (connector, projectName) => ({
  type: types.UPDATE_LINK_CONNECTOR,
  payload: {
    connector,
    projectName,
  },
});
export const UpdateLinkConnectorSuccess = (response) => ({
  type: types.UPDATE_LINK_CONNECTOR_SUCCESS,
  payload: response,
});
export const UpdateLinkConnectorFailed = (error) => ({
  type: types.UPDATE_LINK_CONNECTOR_FAILED,
  payload: error,
});

export const UpdateConnectorList = (connector, projectName) => ({
  type: types.UPDATE_CONNECTOR_LIST,
  payload: {
    connector,
    projectName,
  },
});
//
// ─── VALIDATE CONNECTOR NAME ────────────────────────────────────────────────────
//

export const ValidateConnectorName = (connector) => ({
  type: types.VALIDATE_CONNECTOR_NAME,
  payload: connector,
});
export const ValidateConnectorNameSuccess = (response) => ({
  type: types.VALIDATE_CONNECTOR_NAME_SUCCESS,
  payload: response,
});
export const ValidateConnectorNameFail = (response) => ({
  type: types.VALIDATE_CONNECTOR_NAME_FAILED,
  payload: response,
});

//
// ─── REMOVE VALIDATE CONNECTOR NAME ────────────────────────────────────────────────────
//
export const RemoveValidationName = () => ({
  type: types.REMOVE_VALIDATION_NAME,
});

export const FetchAConnectorConfigStats = (connector) => ({
  type: types.FETCH_A_CONNECTOR_CONFIG_STATS,
  payload: connector,
});

export const FetchAConnectorConfigStatsSuccess = (response) => ({
  type: types.FETCH_A_CONNECTOR_CONFIG_STATS_SUCCESS,
  payload: response,
});

export const FetchAConnectorConfigStatsFailed = (error) => ({
  type: types.FETCH_A_CONNECTOR_CONFIG_STATS_FAILED,
  payload: error,
});

export const ClearConnectorConfigStats = () => ({
  type: types.CLEAR_CONNECTOR_CONFIG_STATS,
});

export const ClearConnectorList = () => ({
  type: types.CLEAR_CONNECTOR_LIST,
});

export const FetchConnectorLogs = (id) => ({
  type: types.FETCH_CONNECTOR_LOGS,
  payload: id,
});

export const FetchConnectorLogsSuccess = (logs) => ({
  type: types.FETCH_CONNECTOR_LOGS_SUCCESS,
  payload: logs,
});

export const FetchConnectorLogsFailed = (error) => ({
  type: types.FETCH_CONNECTOR_LOGS_FAILED,
  payload: error,
});

export const FetchBigQueryMapping = (payload) => ({
  type: types.FETCH_BIGQUERY_MAPPING,
  payload: payload,
});
export const FetchBigQueryMappingSuccess = (list) => ({
  type: types.FETCH_BIGQUERY_MAPPING_SUCCESS,
  payload: list,
});
export const FetchBigQueryMappingFailed = (error) => ({
  type: types.FETCH_BIGQUERY_MAPPING_FAILED,
  payload: error,
});
export const BigqueryUpdate = (payload, id) => ({
  type: types.BIGQUERY_UPDATE,
  payload,
  id,
});
export const BigqueryUpdateSuccess = (response) => ({
  type: types.BIGQUERY_UPDATE_SUCCESS,
  payload: response,
});
export const BigqueryUpdateFailed = (error) => ({
  type: types.BIGQUERY_UPDATE_FAILED,
  payload: error,
});
export const ResetBigqueryUpdateMsgs = () => ({
  type: types.RESET_BIGQUERY_UPDATE_MSGS,
});
export const ClearConnectorError = () => ({
  type: types.CLEAR_CONNECTOR_ERROR,
});
